import * as React from 'react';
import BasicInfoComponent from '../BasicInfo/BasicInfoComponent';
import DataLocationInfoComponent from '../DataLocationInfo/DataLocationInfoComponent';
import ParametersInfoComponent from '../ParametersInfo/ParametersInfoComponent';
import AvailabilityStreamInfoComponent from '../AvailabilityStreamInfo/AvailabilityStreamInfoComponent';
import SpecialColumnsComponent from '../SpecialColumns/SpecialColumnsComponent';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
import { DataProfilingComponent, ProfilingOptions } from '../DataProfiling/DataProfilingComponent';
import { DataLocationStorageType } from '../../models/DataSourceDataCommon';
import DataLinkInfoComponent from '../DataLinkInfo/DataLinkInfoComponent';
import { DataSourceTypes } from '../../../../constants/DataSource.constants';
export var CreateStepKey;
(function (CreateStepKey) {
    CreateStepKey["Basic"] = "basic";
    CreateStepKey["Location"] = "location";
    CreateStepKey["SpecicalColumns"] = "specialcolumns";
    CreateStepKey["Parameters"] = "parameters";
    CreateStepKey["Availability"] = "availability";
    CreateStepKey["Profiling"] = "profiling";
    CreateStepKey["Links"] = "links";
})(CreateStepKey || (CreateStepKey = {}));
export var CreateStepTitle;
(function (CreateStepTitle) {
    CreateStepTitle["Basic"] = "Details";
    CreateStepTitle["Location"] = "Data location";
    CreateStepTitle["SpecialColumns"] = "Special columns";
    CreateStepTitle["Parameters"] = "Parameters";
    CreateStepTitle["Availability"] = "Dependency files";
    CreateStepTitle["Profiling"] = "Data profiling";
    CreateStepTitle["Links"] = "Links";
})(CreateStepTitle || (CreateStepTitle = {}));
export const tabOrder = {
    [CreateStepKey.Basic]: 0,
    [CreateStepKey.Location]: 1,
    [CreateStepKey.SpecicalColumns]: 2,
    [CreateStepKey.Parameters]: 3,
    [CreateStepKey.Availability]: 4,
    [CreateStepKey.Profiling]: 5,
    [CreateStepKey.Links]: 6,
};
export const createStepProperties = (props, state, formikProps) => {
    const { errors = {}, setFieldValue, values } = formikProps || {};
    let tabProperties = {
        [CreateStepKey.Basic]: {
            key: CreateStepKey.Basic,
            title: CreateStepTitle.Basic,
            isError: isErrorInTab(CreateStepKey.Basic, errors, tabOrder),
            tabContent: React.createElement(BasicInfoComponent, { formikProps: formikProps }),
        },
        [CreateStepKey.Location]: {
            key: CreateStepKey.Location,
            title: CreateStepTitle.Location,
            isError: isErrorInTab(CreateStepKey.Location, errors, tabOrder),
            tabContent: React.createElement(DataLocationInfoComponent, { formikProps: formikProps, isCreate: true }),
        },
        [CreateStepKey.SpecicalColumns]: {
            key: CreateStepKey.SpecicalColumns,
            title: CreateStepTitle.SpecialColumns,
            isError: isErrorInTab(CreateStepKey.SpecicalColumns, errors, tabOrder),
            tabContent: (React.createElement(SpecialColumnsComponent, { workspaceId: props.workspaceId, storageType: (values === null || values === void 0 ? void 0 : values.storageType) || '', randomizationList: (values === null || values === void 0 ? void 0 : values.randomizationList) || [], randomizationListErrors: errors.randomizationList, flightList: (values === null || values === void 0 ? void 0 : values.flightList) || [], flightListErrors: errors.flightList, timestampList: (values === null || values === void 0 ? void 0 : values.timestampList) || [], timestampListErrors: errors.timestampList, setFieldValue: setFieldValue })),
        },
        [CreateStepKey.Parameters]: {
            key: CreateStepKey.Parameters,
            title: CreateStepTitle.Parameters,
            isError: isErrorInTab(CreateStepKey.Parameters, errors, tabOrder),
            tabContent: React.createElement(ParametersInfoComponent, { formikProps: formikProps }),
        },
        [CreateStepKey.Availability]: {
            key: CreateStepKey.Availability,
            title: CreateStepTitle.Availability,
            isError: isErrorInTab(CreateStepKey.Availability, errors, tabOrder),
            tabContent: React.createElement(AvailabilityStreamInfoComponent, { formikProps: formikProps }),
        },
    };
    if (EnvironmentService.releaseDSMSdataprofiling() && (values === null || values === void 0 ? void 0 : values.storageType) === DataLocationStorageType.Cosmos) {
        tabProperties = {
            ...tabProperties,
            [CreateStepKey.Profiling]: {
                key: CreateStepKey.Profiling,
                title: CreateStepTitle.Profiling,
                isError: isErrorInTab(CreateStepKey.Profiling, errors, tabOrder),
                tabContent: (React.createElement(DataProfilingComponent, { isEnableProfiling: (values === null || values === void 0 ? void 0 : values.isEnableProfiling) || false, profilingFrequency: (values === null || values === void 0 ? void 0 : values.profilingFrequency) || ProfilingOptions.Manual })),
            },
        };
    }
    let keyOrder = [
        CreateStepKey.Basic,
        CreateStepKey.Location,
        CreateStepKey.SpecicalColumns,
        CreateStepKey.Parameters,
        CreateStepKey.Availability,
    ];
    if (EnvironmentService.releaseDSMSdataprofiling() && (values === null || values === void 0 ? void 0 : values.storageType) === DataLocationStorageType.Cosmos) {
        keyOrder = [...keyOrder, CreateStepKey.Profiling];
    }
    if (EnvironmentService.enableSampleDataSource()) {
        tabProperties = {
            ...tabProperties,
            [CreateStepKey.Links]: {
                key: CreateStepKey.Links,
                title: CreateStepTitle.Links,
                isError: isErrorInTab(CreateStepKey.Links, errors, tabOrder),
                tabContent: (React.createElement(DataLinkInfoComponent, { workspaceId: props.workspaceId, formikProps: formikProps, isReadOnly: !(values === null || values === void 0 ? void 0 : values.dataSourceType) || values.dataSourceType === DataSourceTypes.Sample })),
            },
        };
        keyOrder = [...keyOrder, CreateStepKey.Links];
    }
    return { stepProperties: keyOrder.map((k) => tabProperties[k]) };
};
const isErrorInTab = (createStepKey, errors, tabOrder) => {
    switch (tabOrder[createStepKey]) {
        case tabOrder[CreateStepKey.Basic]:
            if (!!errors.name ||
                !!errors.isUTC ||
                !!errors.owners ||
                !!errors.subscribers ||
                (EnvironmentService.enableSampleDataSource() && !!errors.dataSourceType)) {
                return true;
            }
            break;
        case tabOrder[CreateStepKey.Location]:
            if (!!errors.storageType || !!errors.storageList || !!errors.storageMTList || !!errors.retentionDays) {
                return true;
            }
            break;
        case tabOrder[CreateStepKey.SpecicalColumns]:
            if (!!errors.randomizationList || !!errors.flightList || !!errors.timestampList) {
                return true;
            }
            break;
        case tabOrder[CreateStepKey.Parameters]:
            if (!!errors.parameterList) {
                return true;
            }
            break;
        case tabOrder[CreateStepKey.Availability]:
            if (!!errors.streamList) {
                return true;
            }
            break;
        case tabOrder[CreateStepKey.Profiling]:
            return false;
        case tabOrder[CreateStepKey.Links]:
            return false;
    }
    return false;
};

//# sourceMappingURL=CreateSteps.js.map
